import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import tenderDetailsFormImage from '../../Assets/images/tenderDetailsFormImage.png';
import { AiOutlineClose } from 'react-icons/ai';
import Swal from 'sweetalert2';
import apiClient from '../../Api/apiClient';
import { PHOTO_BASE_URL_Admin } from '../../Api/config';
import { Printer, FileText } from 'lucide-react';
import { ArrowLeft, Share, Share2 } from 'lucide-react';
import ShareTender from '../../Modals/ShareTender';
const ViewMyTenderDetails = () => {
  const location = useLocation();
  const { FromFreeTenders } = location.state || {};
  const navigate = useNavigate();
  const { id } = useParams();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const tender_id = searchParams.get('tender_id');

  const userType = localStorage.getItem('user_type');
  console.log(userType);

  // State for form data and auxiliary inputs
  const [formData, setFormData] = useState({
    org_company_name: '',
    reference_number: '',
    earnest_money: '',
    documents_price: '',
    publish_on: '',
    opening_date: '',
    end_date: '',
    purchase_last_date: '',
    prebid_meeting_date: '',
    prebid_meeting_end_date: '',
    proposal_closing_date: '',
    submission_date: '',
    status: '',
    tender_section: '',
    type: '',
    address: '',
    sub_sector_id: '',
    sub_department_id: '',
    source_id: '',
    upazila_id: '',
    description: '',
  });
  const [logo, setLogo] = useState(null);
  const [orgName, setOrgname] = useState('');
  const [tenderId, setTenderId] = useState(null);
  const [tenderName, setTenderName] = useState('');

  const [loading, setLoading] = useState(true);

  const queryParams = new URLSearchParams();
  if (tender_id) queryParams.append('tender_id', tender_id);

  useEffect(() => {
    const fetchTenderDetails = async () => {
      try {
        setLoading(true);
        const url = `/user/tender-user/published-tender/${id}`;
        if (userType === 'affiliator') {
          url = `/affiliator/tender-request/published-tender/${id}`;
        }

        const response = await apiClient.get(url);
        const data = response.data.data;

        setOrgname(data.org_company_name);
        setTenderName(data.name);
        setTenderId(data.id);
        setLogo(data.company_logo);

        setFormData(prevFormData => ({
          ...prevFormData,
          ...data,
        }));
      } catch (error) {
        console.error('Error fetching tender details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTenderDetails();
  }, [id]);

  // Handle input change
  const handleInputChange = e => {
    const { name, value } = e.target;

    // Convert numeric fields to numbers if necessary
    const numericFields = [
      'sub_sector_id',
      'sub_department_id',
      'source_id',
      'upazila_id',
    ];
    setFormData(prevData => ({
      ...prevData,
      [name]: numericFields.includes(name)
        ? value
          ? Number(value)
          : ''
        : value,
    }));
  };

  const handlePDFview = id => {
    navigate(`/pdf-viewer/${id}`);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-lg font-bold">Loading...</p>
      </div>
    );
  }

  return (
    <>
      <div className="py-0 md:py-4 md:px-10 2xl:px-10 bg-white min-h-screen rounded-lg shadow-sm md:mt-36 mt-32 container mx-auto text-xs">
        <div className="hidden items-center justify-center mb-6 2xl:mb-8 mt-0">
          <img
            src={tenderDetailsFormImage}
            alt="Tender Details Form"
            className="h-32 2xl:h-40"
          />
        </div>

        <div className="flex items-end justify-between mb-2 space-x-2 text-xs px-2">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-2 py-1 bg-orange-500 text-white rounded-md hover:bg-red-600"
          >
            <ArrowLeft size={16} />
          </button>
          <div className="flex gap-2">
            <button
              onClick={() => handlePDFview(id)}
              className="flex items-center gap-2 bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600 transition"
            >
              <FileText className="w-4 h-4" />
              View PDF
            </button>
            <button
              onClick={() => window.print()}
              className="flex items-center gap-2 bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 transition"
            >
              <Printer className="w-4 h-4" />
              Print
            </button>
          </div>
        </div>

        <div className="bg-tenderDetails shadow-md rounded-md md:p-6 p-2 border border-blue-300">
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center space-x-4">
              <img
                src={
                  logo
                    ? `${PHOTO_BASE_URL_Admin}${logo}`
                    : 'https://via.placeholder.com/50'
                }
                alt="Organization Logo"
                className="w-16 h-16 rounded-full"
              />
              <div>
                <h2 className="text-lg font-bold">{tenderName}</h2>
                <p className="text-gray-500">{orgName}</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <form>
            <div className="grid md:grid-cols-2  grid-cols-1 2xl:gap-x-28 md:gap-x-16 gap-x-4 2xl:gap-y-5 gap-y-3">
              {[
                {
                  label: 'Tender Section',
                  name: 'tender_section',
                  type: 'text',
                },

                {
                  label: 'Reference Number',
                  name: 'ref_no',
                  type: 'text',
                },
                {
                  label: 'Org/Company Name',
                  name: 'invitation_for',
                  type: 'text',
                },
                { label: 'Type', name: 'type', type: 'text' },
                { label: 'Source Type', name: 'source_type', type: 'text' },
                { label: 'Source Name', name: 'source_name', type: 'text' },
                {
                  label: 'Department Name',
                  name: 'department_name',
                  type: 'text',
                },
                {
                  label: 'Sub-department Name',
                  name: 'sub_department_name',
                  type: 'text',
                },
                { label: 'Category Name', name: 'category_name', type: 'text' },
                { label: 'Sector Name', name: 'sector_name', type: 'text' },
                {
                  label: 'Sub-sector Name',
                  name: 'sub_sector_name',
                  id: 'sub_sector_id',
                  type: 'text',
                },
                { label: 'Division Name', name: 'division_name', type: 'text' },
                { label: 'District Name', name: 'district_name', type: 'text' },
                { label: 'Upazila Name', name: 'upazila_name', type: 'text' },
                { label: 'Published on', name: 'publish_on', type: 'text' },
                {
                  label: 'Purchase Last Date',
                  name: 'purchase_last_date',
                  type: 'text',
                },
                {
                  label: 'Prebid Meeting Start Date',
                  name: 'prebid_meeting_date',
                  type: 'text',
                },
                {
                  label: 'Prebid Meeting End Date',
                  name: 'prebid_meeting_end_date',
                  type: 'text',
                },
                {
                  label: 'Proposal Closing Date',
                  name: 'proposal_closing_date',
                  type: 'text',
                },
                { label: 'Opening Date', name: 'opening_date', type: 'text' },
                {
                  label: 'Submission Date',
                  name: 'submission_date',
                  type: 'text',
                },
                { label: 'Address', name: 'address', type: 'text' },
                { label: 'Documents', name: 'file_upload', type: 'text' },

                { label: 'Earnest Money', name: 'earnest_money', type: 'text' },
                {
                  label: 'Document Price',
                  name: 'documents_price',
                  type: 'text',
                },
                { label: 'Status', name: 'status', type: 'text' },

                { label: 'End Date', name: 'end_date', type: 'text' },

                { label: 'Create at', name: 'created_at', type: 'text' },
                { label: 'Description', name: 'description', type: 'text' },
                // { label: 'Documents', name: 'file_upload', type: 'text' },
              ]
                .filter(
                  ({ name }) => formData[name] && formData[name] !== 'N/A'
                )
                .map(({ label, name, type }) => (
                  <div
                    key={name}
                    className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0 space-y-2"
                  >
                    <label
                      htmlFor={name}
                      className="block text-sm font-medium text-gray-700 w-full sm:w-1/3"
                    >
                      {label}:
                    </label>

                    {label === 'Documents' ? (
                      <div className="flex flex-col sm:flex-row sm:items-center gap-1 w-full">
                        <input
                          id={name}
                          name={name}
                          type="text" // Assuming the file URL is stored as text
                          value={formData[name] || 'N/A'}
                          onChange={handleInputChange}
                          className="p-2 border-2 rounded-md shadow-sm focus:outline-none focus:ring-0 text-xs w-full md:ml-12 2xl:ml-14 md:block hidden"
                          readOnly
                        />
                        <a
                          onClick={() => handlePDFview(id)}
                          className="flex justify-center items-center border border-gray-300 px-2 py-2 text-xs rounded-md shadow-sm w-full sm:w-1/3 bg-white text-black hover:text-blue-600 hover:border-blue-600 cursor-pointer"
                        >
                          📄 View PDF
                        </a>
                      </div>
                    ) : (
                      <input
                        id={name}
                        name={name}
                        type={type}
                        value={
                          name === 'status'
                            ? formData[name] === 1
                              ? 'Active'
                              : 'Expired'
                            : formData[name] || 'N/A'
                        }
                        onChange={handleInputChange}
                        className="flex-1 p-2 border-2 rounded-md shadow-sm text-xs focus:outline-none focus:ring-0"
                        readOnly
                      />
                    )}
                  </div>
                ))}
            </div>

            {/* Buttons */}
            <div className="mt-6 flex justify-center d gap-4">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-red-600"
              >
                Close View
              </button>
            </div>
          </form>

          {/* <div className="">
                        <button
                            onClick={() => setIsShareModalOpen(true)}
                            className="fixed right-4 top-[580px] transform -translate-y-1/2 bg-DefaultColor text-white py-1 px-2 shadow-lg rounded hover:bg-DefaultHoverColor transition duration-300 text-xs md:text-sm"
                        >
                            <Share2 className="w-4 h-4" />
                        </button>
                    </div> */}

          <ShareTender
            isOpen={isShareModalOpen}
            onClose={() => setIsShareModalOpen(false)}
            tender_id={tenderId}
          />
        </div>
      </div>
    </>
  );
};

export default ViewMyTenderDetails;
